'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getThemeColor = getThemeColor;
exports.applyTheme = applyTheme;
var styleVars = document.querySelector(':root');

function getThemeColor(colorName) {
    // Get the styles (properties and values) for the root
    var style = getComputedStyle(styleVars);
    return style.getPropertyValue(colorName);
}

// Create a function for setting a variable value

function setThemeColor(colorName, colorHash) {
    // Set the value of variable to another Value
    styleVars.style.setProperty(colorName, colorHash);
}

var themeColors = [{ name: '--logo-path', carsNow: 'url(../../../images/logo.png)', leadManager: 'url(../../../images/leadmanager/logo.png)' }, { name: '--default-color', carsNow: '#4d585a', leadManager: '#233D4D' }, { name: '--default-color-hover', carsNow: '#596568', leadManager: '#596568' }, { name: '--primary-color', carsNow: '#ffd700', leadManager: '#56c4f0' }, { name: '--primary-color-hover', carsNow: '#ffdb1a', leadManager: '#6bc1e3' }, { name: '--success-color', carsNow: '#3d9648', leadManager: '#3d9648' }, { name: '--success-color-hover', carsNow: '#44a851', leadManager: '#44a851' }, { name: '--danger-color', carsNow: '#ed1c24', leadManager: '#ed1c24' }, { name: '--danger-color-hover', carsNow: '#ef343b', leadManager: '#ef343b' }, { name: '--topNav-user-text', carsNow: '#4e5757', leadManager: '#4e5757' }, { name: '--dashboard-odd-panel-mainColor', carsNow: '#ffe247', leadManager: '#61A5C2' }, { name: '--dashboard-odd-panel-gradColor', carsNow: '#ffe660', leadManager: '#A9D6E5' }, { name: '--dashboard-even-panel-mainColor', carsNow: '#cdccbc', leadManager: '#ADB5BD' }, { name: '--dashboard-even-panel-gradColor', carsNow: '#c2c2b4', leadManager: '#DEE2E6' }, { name: '--report-even-row', carsNow: '#FFF8D3', leadManager: '#bde0fe' }, { name: '--report-even-hover', carsNow: '#FFD700', leadManager: '#a2d2ff' }];

function applyTheme(isLeadManager) {
    themeColors.map(function (col) {
        setThemeColor(col.name, isLeadManager ? col.leadManager : col.carsNow);
    });
}


// WEBPACK FOOTER //
// ./client/app/app.theme.js